import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faMinus, faLayerGroup } from '@fortawesome/free-solid-svg-icons'
import MultiSelect from '../../components/Select/MultiSelect';
import './UserForm.css';
import Button from '../../components/Button/Button';

const UserSubjectClassMapping = ({ handleChange, subjectChangeHandler, onSubjectRemove,
  addNewRow, clickOnDelete, state
}) => {
  return (
    <div className="user-form-section">
      <div className="user-form-section-title">
        <span className="icon-badge"><FontAwesomeIcon icon={faLayerGroup} /></span>
        <span>Class &amp; Subject Mapping</span>
      </div>
      <div className="row">
        <div className="col-md-4">
          <label className="user-form-field-label">Class</label>
        </div>
        <div className="col-md-4">
          <label className="user-form-field-label">Subject</label>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          {state.programs.map((val, idx) => {
            return (
              <div className="row mb-3 align-items-start" key={idx}>
                <div className="col-md-4 user-form-field">
                  <select
                    name="id"
                    data-id={idx}
                    className="form-select form-control cursor-pointer user-form-select"
                    value={val.id}
                    onChange={(e) => handleChange(e, idx)}
                    placeholder="Select class"
                  >
                    <option value="all">Choose Class</option>
                    {state.programData && state.programData.map((program) => (
                      <option value={program.id} key={program.id}>
                        {program.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4">
                  <MultiSelect
                    name="subjects"
                    options={val.subject_list ? val.subject_list : state.subjectData}
                    data-id={idx}
                    id={val && val.subjects ? val.subjects : []}
                    selectedValues={val && val.subjects ? val.subjects : []}
                    onRemove={(e) =>
                      onSubjectRemove(e, val.id)
                    }
                    onChangeHandler={(e) =>
                      subjectChangeHandler(e, idx)
                    }
                    displayValue="name"
                    closeOnSelect={false}
                    placeholder="Select Subject"
                  />
                </div>
                <div className="col-md-4">
                  {idx === 0 ? (
                    <Button
                      variant="primary"
                      onClick={addNewRow}
                      type="button"
                      className="text-center rounded-circle"
                      title="Add another class"
                    >
                      <FontAwesomeIcon icon={faPlusCircle} />
                    </Button>
                  ) : (
                    <Button
                      variant="danger"
                      className="rounded-circle"
                      onClick={() => clickOnDelete(val)}
                      type="button"
                      title="Remove this row"
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </Button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default UserSubjectClassMapping;
